export default __webpack_public_path__ + "static/media/SamPinkowski.1b1580a4.jpg";